import {
  Card, CardContent, CardHeader,
  Divider, List, Typography,
  ListItem, ListItemText,
  ListItemSecondaryAction, IconButton, Chip, Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { loadBaslandiJob,saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  content: {
    minHeight: 430,
  },
  divider: {
    backgroundColor: '#FF9800'
  },
}));

function Bakim({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [BakimTeklifDetay, setBakimTeklifDetay] = React.useState([]);
  const SessionUser = getUser();
  let BakimData = readonly ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : loadBaslandiJob();

  if (!readonly && (!BakimData || BakimData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      BakimData = loadBaslandiJob();
    }
  }

  let MusteriNo = BakimData[0]?.MusteriNo;
  let ServiceShopId = SessionUser.ServiceShopId;
  let TechnicianId = SessionUser.TechnicianId;

  const SorgulaTeklif = (FisNo, ServiceShopId, TechnicianId, MusteriNo) => {
    setLoadingControl(true);
    axios.get('/GetArtemisBakimTeklif/' + FisNo + '/' + ServiceShopId + '/' + TechnicianId + '/' + MusteriNo)
      .then(response => {
        const Deger = response.data;

        if (Deger.length === 0) {
          setBakimTeklifDetay([]);
        } else {
          setBakimTeklifDetay(Deger);
        }
        setLoadingControl(false);
      }).catch(error => {
        setBakimTeklifDetay([]);
        setUyariTip("error");
        setUyariAciklama("Müşterimizin Bakim Teklif edilebilecek ürünü bulunmamaktadır!...");
        setUyari(true);
        setLoadingControl(false);
       logger.error("Hata detayı:", error.message);       
      });
  }



  useEffect(() => {
    SorgulaTeklif(FisNo, ServiceShopId, TechnicianId, MusteriNo);
  }, [FisNo, ServiceShopId, TechnicianId, MusteriNo]);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const BakimSatisYapEvet = (log) => {
    setLoadingControl(true);
    const data = {
      FisNo: parseInt(FisNo),
      MODEL_KODU: log.MODEL_KODU,
      UYIL: log.UYIL,
      UDONEM: log.UDONEM.toString(),
      SERINO: log.SERINO,
      NITELIK_KODU: log.NITELIK_KODU,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TechnicianId: SessionUser.TechnicianId,
      USER_ID: SessionUser.OrganizationUserId,
      BASVURU_NEDENI: log.BasvuruNedeni,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisBakimSatisYap', data, config)
      .then(response => {
        setLoadingControl(false);
        if (response.data.ErrorCode === "0") {
          setUyariTip("success");
          setUyariAciklama("İşleminiz Başarı ile Gerçekleştirildi!...");
          setUyari(true);
          SorgulaTeklif(FisNo, ServiceShopId, TechnicianId, MusteriNo);
        } else {
          setLoadingControl(false);
          setUyariTip("error");
          setUyariAciklama(response.data.ErrorDescription);
          setUyari(true);
        }
      }).catch(error => {
        setLoadingControl(false);
        setUyariTip("error");
        setUyariAciklama(error.message);
        setUyari(true);
      });
  }
  const BakimSatisYap = (log) => {
    var Uyari = "Müşterimizin " + log.KUL_MODEL_KODU + "-" + log.MODEL + " ürününe ait " + log.FIYAT + " TL bakım fişi oluşturulacaktır. Onaylıyor musunuz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => BakimSatisYapEvet(log)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={"Bakim Teklif"} />
      <Divider />
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div></div>
      }
      <CardContent className={classes.content}>
        {
          LoadingControl ?
            <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />
            :
            BakimTeklifDetay.length === 0 ?
              <Grid container spacing={0} >
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Müşterimizin Bakım Teklif edilebilecek ürünü bulunmamaktadır!...
                  </Typography>
                </Grid>
                <Grid item xs={12} align={'center'}>
                  <IconButton
                    color="primary">
                    <ClearAllIcon size="large" />
                  </IconButton>
                </Grid>
              </Grid>
              :
              <List className={classes.root}>
                {BakimTeklifDetay.sort((a, b) => { return a.KUL_MODEL_KODU - b.KUL_MODEL_KODU }).map(log => (
                  <div key={log.KUL_MODEL_KODU}>
                    <ListItem alignItems="flex-start">
                      <ListItemText>
                        <Typography
                          component="span"
                          variant="body1"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          <b>Marka:</b> {log.MARKA}
                          <br />
                          <b>Ürün Kodu:</b> {log.KUL_MODEL_KODU}
                          <br />
                          <b>Ürün:</b> {log.MODEL}
                          <br />
                          <b>Basvuru Nedeni:</b> {log.BasvuruNedeni}
                          <br />
                          <Chip size="small" label={log.FIYAT + ' ₺'} color="secondary" />
                        </Typography>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <IconButton
                          color="primary"
                          edge="end"
                          onClick={() => BakimSatisYap(log)}
                          size="small">
                          <LibraryAddIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider className={classes.divider} />
                  </div>
                ))}
              </List>

        }
      </CardContent>
    </Card >
  );
}

Bakim.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(Bakim);
